import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#4b717a] text-white pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
        {/* Brand */}
        <div className="flex flex-col gap-6">
          <div className="flex items-center gap-4">
            <img 
              src="https://assets.auxodev.dk/assets/3d56beb5-25cd-44c2-a35b-95780bd285dd/e2a4c047-e995-4b00-9d03-e5cce2d849d8.png" 
              alt="Hellerup Lægehus Logo" 
              className="h-20 w-auto"
            />
          </div>
          <p className="text-white/70 text-sm leading-relaxed max-w-xs">
            Din lokale læge i Hellerup. Vi tilbyder professionel behandling og omsorg for hele familien.
          </p>
        </div>

        {/* Contact */}
        <div className="flex flex-col gap-6">
          <h3 className="text-xs font-sans tracking-[0.3em] uppercase text-white font-bold">Kontakt</h3>
          <ul className="flex flex-col gap-4">
            <li className="flex items-start gap-3 text-white/90 group">
              <MapPin size={18} className="text-white shrink-0 mt-1" />
              <span className="text-sm leading-relaxed">
                Bernstorffsvej 20 C, 2.sal<br />
                2900 Hellerup
              </span>
            </li>
            <li className="flex items-center gap-3 text-white/90 group">
              <Phone size={18} className="text-white shrink-0" />
              <a href="tel:70602202" className="text-sm hover:text-white transition-colors">70 60 22 02</a>
            </li>
            <li className="text-xs text-white/50 ml-8 -mt-2">
              Telefontid 8-12 (lukket 10-10.15)
            </li>
          </ul>
        </div>

        {/* Opening Hours */}
        <div className="flex flex-col gap-6">
          <h3 className="text-xs font-sans tracking-[0.3em] uppercase text-white font-bold">Åbningstider</h3>
          <ul className="flex flex-col gap-2">
            {[
              { day: 'Mandag', hours: '8:00 - 16:00' },
              { day: 'Tirsdag', hours: '8:00 - 16:00' },
              { day: 'Onsdag', hours: '8:00 - 17:30' },
              { day: 'Torsdag', hours: '8:00 - 16:00' },
              { day: 'Fredag', hours: '8:00 - 16:00' },
            ].map((item) => (
              <li key={item.day} className="flex justify-between text-sm border-b border-white/10 pb-2">
                <span className="text-white/70">{item.day}</span>
                <span className="text-white font-mono">{item.hours}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Quick Links */}
        <div className="flex flex-col gap-6">
          <h3 className="text-xs font-sans tracking-[0.3em] uppercase text-white font-bold">Genveje</h3>
          <ul className="flex flex-col gap-3">
            {['Hjem', 'Personale', 'Ydelser', 'Praktisk Info', 'Find vej', 'Kontakt'].map((link) => (
              <li key={link}>
                <Link 
                  to={link === 'Hjem' ? '/' : `/${link.toLowerCase().replace(' ', '-')}`}
                  className="text-sm text-white/70 hover:text-white transition-colors"
                >
                  {link}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 pt-10 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-xs text-white/40 tracking-widest uppercase">
          &copy; Copyright 2026. All rights reserved. | Helleruplægehus | <Link to="/privat" className="hover:text-white transition-colors">Privatlivspolitik</Link>
        </p>
        <div className="flex gap-6">
          <span className="text-xs text-white/40 tracking-widest uppercase">Design af ravn-hjemmesider.dk</span>
        </div>
      </div>
    </footer>
  );
}
